import i18n from '@i18next/i18n';
export const ButtonType = {
    TOOLTIP: 'Tooltip',
    SEPARATOR: 'Separator',
    DROPDOWN: 'DropDown',
    DUIDROPDOWN: 'DuiDropDown',
};
// 默认视频的菜单列表配置
// 按照前后顺序排列，可加入separator配置

const OPEN_LINK_BUTTON = {
    type: ButtonType.TOOLTIP, // 按钮类型
    id: 'url',
    text: i18n.t('打开链接'),
    config: { // 其他定制配置
        tipText: i18n.t('跳转到源网页'),
    },
};

const COPY_LINK_BUTTON = {
    type: ButtonType.TOOLTIP, // 按钮类型
    id: 'copyUrl',
    icon: '', // 按钮上的图标
    config: { // 其他定制配置
        tipText: i18n.t('复制链接'),
    },
};

const MODIFY_LINK_BUTTON = {
    type: ButtonType.TOOLTIP, // 按钮类型
    id: 'modifyUrl',
    icon: '', // 按钮上的图标
    config: { // 其他定制配置
        tipText: i18n.t('修改链接'),
    },
};

const CANCEL_LINK_BUTTON = {
    type: ButtonType.TOOLTIP, // 按钮类型
    id: 'cancelUrl',
    icon: '', // 按钮上的图标
    config: { // 其他定制配置
        tipText: i18n.t('取消链接'),
    },
};

const REFRESH_BUTTON = {
    type: ButtonType.TOOLTIP, // 按钮类型
    id: 'refresh',
    config: { // 其他定制配置
        tipText: i18n.t('刷新'),
    },
};

const DELETE_BUTTON = {
    type: ButtonType.TOOLTIP, // 按钮类型
    id: 'delete',
    config: { // 其他定制配置
        tipText: i18n.t('删除'),
    },
};

const FULLSCREEN_BUTTON = {
    type: ButtonType.TOOLTIP, // 按钮类型
    id: 'fullscreen',
    config: { // 其他定制配置
        tipText: i18n.t('全屏查看'),
    },
};

const SEPARATOR_LINE = {
    type: ButtonType.SEPARATOR,
    config: {
        block: 'line',
    },
};

const SEPARATOR_BLOCK = {
    type: ButtonType.SEPARATOR,
    config: {
        block: 'block',
    },
};

export const NORMAL_LINK = [
    OPEN_LINK_BUTTON,
    SEPARATOR_LINE,
    COPY_LINK_BUTTON,
    SEPARATOR_BLOCK,
    MODIFY_LINK_BUTTON,
    SEPARATOR_LINE,
    {
        type: ButtonType.DROPDOWN, // 下拉按钮
        id: 'changeDisplay',
        config: { // 其他定制配置
            tipText: i18n.t('展示样式'),
            items: [{
                name: i18n.t('文字链'),
                isSelected: false,
                id: 'normal',
            },
            {
                name: i18n.t('图标+文字链'),
                isSelected: true,
                id: 'icon',
            }],
        },
    },
    SEPARATOR_LINE,
    CANCEL_LINK_BUTTON,
];

// 形状/图片等元素链接不提供切换样式功能
export const ELEMENT_LINK = [
    OPEN_LINK_BUTTON,
    SEPARATOR_LINE,
    COPY_LINK_BUTTON,
    SEPARATOR_BLOCK,
    MODIFY_LINK_BUTTON,
    SEPARATOR_LINE,
    CANCEL_LINK_BUTTON,
];

export const ADDON_LINK = [
    OPEN_LINK_BUTTON,
    SEPARATOR_LINE,
    COPY_LINK_BUTTON,
    SEPARATOR_BLOCK,
    MODIFY_LINK_BUTTON,
    SEPARATOR_LINE,
    {
        type: ButtonType.DROPDOWN, // 下拉按钮
        id: 'changeDisplay',
        icon: '', // 按钮上的图标
        config: { // 其他定制配置
            tipText: i18n.t('展示样式'),
            items: [{
                name: i18n.t('文字链'),
                isSelected: true,
                id: 'normal',
            },
            {
                name: i18n.t('图标+文字链'),
                isSelected: false,
                id: 'icon',
            },
            {
                name: i18n.t('预览'),
                isSelected: false,
                id: 'iframe',
            }],
        },
    },
    SEPARATOR_LINE,
    CANCEL_LINK_BUTTON,
];

export const ADDON_ICON_LINK = [
    OPEN_LINK_BUTTON,
    SEPARATOR_LINE,
    COPY_LINK_BUTTON,
    SEPARATOR_BLOCK,
    MODIFY_LINK_BUTTON,
    SEPARATOR_LINE,
    {
        type: ButtonType.DROPDOWN, // 下拉按钮
        id: 'changeDisplay',
        icon: '', // 按钮上的图标
        config: { // 其他定制配置
            tipText: i18n.t('展示样式'),
            items: [{
                name: i18n.t('文字链'),
                isSelected: false,
                id: 'normal',
            },
            {
                name: i18n.t('图标+文字链'),
                isSelected: true,
                id: 'icon',
            },
            {
                name: i18n.t('预览'),
                isSelected: false,
                id: 'iframe',
            }],
        },
    },
    SEPARATOR_LINE,
    CANCEL_LINK_BUTTON,
];

// 编辑权限：可编辑，可复制

export const EDITABLE = [
    OPEN_LINK_BUTTON,
    SEPARATOR_LINE,
    COPY_LINK_BUTTON,
    SEPARATOR_BLOCK,
    MODIFY_LINK_BUTTON,
    SEPARATOR_LINE,
    {
        type: ButtonType.DROPDOWN, // 下拉按钮
        id: 'changeDisplay',
        config: { // 其他定制配置
            tipText: i18n.t('展示样式'),
            items: [{
                name: i18n.t('文字链'),
                isSelected: false,
                id: 'normal',
            },
            {
                name: i18n.t('图标+文字链'),
                isSelected: false,
                id: 'icon',
            },
            {
                name: i18n.t('预览'),
                isSelected: true,
                id: 'iframe',
            }],
        },
    },
    SEPARATOR_LINE,
    REFRESH_BUTTON,
    SEPARATOR_LINE,
    DELETE_BUTTON,
];

export const EDITABLE_FULLSCREEN  = [
    OPEN_LINK_BUTTON,
    SEPARATOR_LINE,
    COPY_LINK_BUTTON,
    SEPARATOR_BLOCK,
    MODIFY_LINK_BUTTON,
    SEPARATOR_LINE,
    {
        type: ButtonType.DROPDOWN, // 下拉按钮
        id: 'changeDisplay',
        config: { // 其他定制配置
            tipText: i18n.t('展示样式'),
            items: [{
                name: i18n.t('文字链'),
                isSelected: false,
                id: 'normal',
            },
            {
                name: i18n.t('图标+文字链'),
                isSelected: false,
                id: 'icon',
            },
            {
                name: i18n.t('预览'),
                isSelected: true,
                id: 'iframe',
            }],
        },
    },
    SEPARATOR_LINE,
    FULLSCREEN_BUTTON,
    SEPARATOR_BLOCK,
    REFRESH_BUTTON,
    SEPARATOR_LINE,
    DELETE_BUTTON,
];

export const ADDON = [
    SEPARATOR_LINE,
    {
        type: ButtonType.DUIDROPDOWN, // 下拉按钮
        id: 'addon',
        config: { // 其他定制配置
            tipText: i18n.t('插件'),
            items: [{}],
        },
    },
];

// 查看权限：可查看，可复制，不可删除

export const ONLY_VIEW = [
    OPEN_LINK_BUTTON,
    SEPARATOR_LINE,
    COPY_LINK_BUTTON,
    SEPARATOR_LINE,
    REFRESH_BUTTON,
];
export const ONLY_VIEW_LINK = [
    OPEN_LINK_BUTTON,
    SEPARATOR_LINE,
    COPY_LINK_BUTTON,
];
export const ONLY_VIEW_FULLSCREEN = [
    OPEN_LINK_BUTTON,
    SEPARATOR_LINE,
    COPY_LINK_BUTTON,
    SEPARATOR_LINE,
    FULLSCREEN_BUTTON,
    SEPARATOR_BLOCK,
    REFRESH_BUTTON,
];

// 查看禁止复制：可查看，禁止复制、不可删除
export const NO_COPY = [
    OPEN_LINK_BUTTON,
    SEPARATOR_LINE,
    REFRESH_BUTTON,
];
export const NO_COPY_LINK = [
    OPEN_LINK_BUTTON,
];
export const NO_COPY_FULLSCREEN = [
    OPEN_LINK_BUTTON,
    SEPARATOR_LINE,
    FULLSCREEN_BUTTON,
    SEPARATOR_BLOCK,
    REFRESH_BUTTON,
];
